import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, noop } from 'lodash';
import { normalizeAmount } from '../../../utils/transformer.util';
import { Button } from '../../../components/base/index';
import PsikomotorikForm from './components/PsikomotorikForm.component';
import PsikomotorikTable from './components/PsikomotorikTable.component';

export default class Psikomotorik extends Component {
  constructor(props) {
    super(props);
    this._onClickAdd = this._onClickAdd.bind(this);
    this._onClickEdit = this._onClickEdit.bind(this);
    this._onClickAddGroup = this._onClickAddGroup.bind(this);
    this._onFormChange = this._onFormChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);

    this.state = {
      coa: {
        loading: true,
        list: [],

      },
      form: {
        value: {},
        error: {},
      },
    };
  }

  componentDidMount() {
    const { handleGetClasses } = this.props;
    handleGetClasses();
  }


  _onClickAdd() {
    const { history } = this.props;
    history.push('/dashboard/kesiswaan');
  }

  _onClickEdit(val) {
    const { history } = this.props;
    history.push('/dashboard/kesiswaan/pendaftaran', { data: val });
  }

  _onClickAddGroup() {
    const { history } = this.props;
    history.push('/dashboard/kesiswaan/displiner/buat-group');
  }

  _onFormChange(event) {
    const {
      name,
      value,
      dataset,
      checked,
      type,
    } = event.target;
    const {
      inputType = 'text', inputArray = false, arrayPosition = 0,
      fieldName,
    } = dataset;
    this.setState((prevState) => {
      let newList = [];
      let newListError = [];
      let formattedValue = value;

      if (inputType === 'number') {
        formattedValue = normalizeAmount(value);
      }
      if (inputArray) {
        if (type === 'checkbox') {
          formattedValue = checked;
        }
        newList = prevState.form.value[fieldName];
        newListError = prevState.form.error[fieldName];
        newList[arrayPosition][name] = formattedValue;
        if (name === 'code_of_account') {
          newList[arrayPosition].isCredit = value.type;
        }
        if (!isEmpty(newListError[arrayPosition])) {
          newListError[arrayPosition][name] = '';
        }
      }
      return {
        form: {
          value: {
            ...prevState.form.value,
            ...(inputArray
              ? { [fieldName]: newList }
              : { [name]: formattedValue }),
          },
          error: {
            ...prevState.form.error,
            ...(inputArray
              ? { [fieldName]: newListError }
              : { [name]: '' }),
          },
        },
      };
    });
  }

  onSubmit(e) {
    e.preventDefault();
    // const { form} = this.state;
    const { form } = this.state;
    const { handleAddBudget, history, user } = this.props;
    const { workingUnit, prm_school_units_id } = user;

    let unit_id = prm_school_units_id;

    if (unit_id === null && workingUnit && workingUnit.id) {
      unit_id = workingUnit.id;
    }
    handleAddBudget(form.value, history.goBack, unit_id);
    // handleAddBudget(form.value, plafon, history.goBack, unit_id);
    // handleAddBudget(form.value, history.goBack, unit_id);
  }


  render() {
    const { form } = this.state;
    const {
      handleGetKelas, handleDeleteKelas, coa, classes = {},
    } = this.props;
    return (
      <div className="add-budget">

        <form onSubmit={this.onSubmit}>
          <div className="budget__title">
            <h1>Daftar Nilai Psikomotorik Siswa Kurikulum 2013</h1>
            <hr />
          </div>

          <PsikomotorikForm
            classes={classes}
            form={form}
            onFormChange={this._onFormChange}
          />
          <div className="manage-registration__footer">
            <div className="manage-registration__button-wrapper">
              { <Button
                onClick={this._onClickAdd}
                title="Tambah Komen Otomatis"
              />
              }
              {
                <Button
                  onClick={this._onClickLaporan}
                  title="Cetak Ke Printer"
                />
           }

            </div>
          </div>

          <PsikomotorikTable
            form={form}
            onFormChange={this._onFormChange}
          />
          <div className="manage-registration__footer">
            <div className="nilai-ktsp__button-wrapper">
              { <Button
                onClick={this._onClickAdd}
                title="Simpan Ke Raport"
              />
              }
              {
                <Button
                  onClick={this._onClickLaporan}
                  title="Edit"
                />
           }

              {
                <Button
                  onClick={this._onClickLaporan}
                  title="Download CSV / PDF"
                />
           }

            </div>
          </div>

        </form>
      </div>
    );
  }
}
Psikomotorik.propTypes = {

  handleGetStudent: PropTypes.func,
  handleDeleteStudent: PropTypes.func,
  history: PropTypes.object.isRequired,
  handleGetClasses: PropTypes.func,
};
Psikomotorik.defaultProps = {
  handleGetClasses: noop,
  handleGetStudent: noop,
  handleDeleteStudent: noop,
};
